module.exports = __webpack_public_path__ + "img/8@2x.b37bb178.png";